function initProductFilters() {
    const toggleButton = document.getElementById('js-toggle-filters');
    const filterForm = document.getElementById('js-filter-form');
    const filtersWrapper = document.querySelector('.facets-filter-wrapper');

    // Check if filters are active in URL params
    const currentParams = new URLSearchParams(window.location.search);
    const hasActiveFilters = Array.from(currentParams.keys()).some(key =>
        key.startsWith('filter_')
    );

    if (hasActiveFilters && filtersWrapper) {
        filtersWrapper.classList.add('visible');
    }
    // Toggle filter form visibility
    if (toggleButton && filtersWrapper) {
        toggleButton.addEventListener('click', () => {
            filtersWrapper.classList.toggle('visible');
        });
    }

    // If no filter form, exit
    if (!filterForm) return;

    filterForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const params = new URLSearchParams();
        const active = {};

        const checkedInputs = filterForm.querySelectorAll('.js-filter-input:checked');

        checkedInputs.forEach(el => {
            const tax = el.dataset.tax;
            if (!active[tax]) active[tax] = [];
            active[tax].push(el.value);
        });

        for (const key in active) {
            params.set(key, active[key].join(','));
        }

        window.location.href = window.location.pathname + '?' + params.toString();
    });
}

